import React from 'react'

function Card(props) {
  return (
    <>
      <div className='card-container'>
  
      <div>

      <p>{props.secret}</p>
      </div>
      
      </div>

    </>
  )
}

export default Card;
